import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { useNavigate } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Link,
  Typography,
} from "@mui/material";

import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { handlePagingAll } from "../../components/api/APIUtilities";
import { postNotification } from "../../components/utilities/Notifications";
import ListResponsive from "../../components/other/ListResponsive";
import {
  BCPImageSlash,
  BCPSquarePlus,
} from "../../components/icons/bcp/BCPIcons";
import { getData } from "../../components/utilities/UtilityFunctions";

const fetchFile = async (fileId) => {
  if (!fileId) return;

  var returnObj;
  try {
    returnObj = await getData(`/files/${fileId}`, {
      queryStringParameters: {},
    });
  } catch (err) {
    console.error(err);
  }
  return returnObj;
};

const ImagePreview = (props) => {
  const { fileId, alt, outerSX } = props;
  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState(null);
  useEffect(() => {
    const go = async () => {
      setLoading(true);
      if (!fileId) {
        setImage(null);
        setLoading(false);
        return;
      }

      if (image) {
        if (image.id === fileId) {
          setLoading(false);
          return;
        }
        setImage(null);
      }

      try {
        var file = await fetchFile(fileId);
        if (file) {
          setImage({
            id: fileId,
            ...file,
          });
        }
      } catch (err) {
        //
      }
      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, [fileId]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "50px",
        minHeight: "50px",
        maxHeight: "50px",
        p: 1,
        border: 1,
        borderColor: "divider",
        ...outerSX,
      }}
    >
      {!loading && image?.url && (
        <img
          src={image.url}
          alt={alt}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}
      {!loading && !image?.url && <BCPImageSlash />}
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};

export default function StoreAdminCategories() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [subLoading, setSubLoading] = useState(true);
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    const go = async () => {
      if (authContext?.authState?.identity?.isAdmin !== true) {
        navigate("/home");
        setLoading(false);
        return;
      }
      try {
        setSubLoading(true);
        var apiCategories = await handlePagingAll(`/productcategories`, {
          limit: 100,
        });
        setCategories(apiCategories);
        setSubLoading(false);
      } catch (err) {
        postNotification("error", err);

        setLoading(false);
        return;
      }
      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container sx={{ gap: 2 }}>
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 1,
              backgroundColor: "background.secondary",
            }}
          >
            <Typography variant="h3">Categories</Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 1,
              backgroundColor: "background.secondary",
            }}
          >
            <ListResponsive
              originalList={subLoading ? null : categories}
              doSearch
              doPages
              initialRowsPerPage={25}
              actionButton={{
                props: {
                  variant: "contained",
                  color: "primary",
                  fullWidth: true,
                  href: "/admin/shop/category",
                  startIcon: <BCPSquarePlus />,
                },
                label: "New Category",
              }}
              searchProps={{
                label: "Search Categories",
                performSearch: (originalList, searchText) => {
                  if (!searchText || searchText === "") {
                    return originalList;
                  } else {
                    var filteredList = originalList.filter(function (el) {
                      if (el?.name?.toLowerCase().includes(searchText))
                        return true;

                      return false;
                    });
                    return filteredList;
                  }
                },
              }}
              rowProps={{
                headings: <RowItem heading />,
                mapFunction: (row, index) => <RowItem key={index} row={row} />,
              }}
            />
          </Grid>
        </Grid>
      </Container>
      {loading && <ModalLoadingFull />}
    </>
  );
}

const RowItem = (props) => {
  const { heading, row } = props;

  const Content = () => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          {heading ? (
            <Typography variant="body1">Category</Typography>
          ) : (
            <Grid container>
              <Grid item xs sx={{ maxWidth: ["50px", "70px"] }}>
                <ImagePreview fileId={row?.imageFileId} alt={row.name} />
              </Grid>
              <Grid item xs>
                <Typography variant="body1">{row.name}</Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid
      item
      xs={12}
      sx={{
        p: 1,
        mb: 1,
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: 1,
        boxShadow: 1,
      }}
    >
      {heading ? (
        <Content />
      ) : (
        <Link href={`/admin/shop/category/${row?.id}`} underline="none">
          <Content />
        </Link>
      )}
    </Grid>
  );
};
